export default __webpack_public_path__ + "static/media/education.04f88f1a.png";